<section class="py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <section
    class="container mx-auto rounded-3xl flex flex-col gap-8 xl:flex-row justify-center items-center"
  >
    <!-- Text -->
    <div
      class="text-center flex flex-col gap-5 xl:gap-7 justify-center items-center py-7 xl:py-4 px-3.5 lg:p-10 w-full basis-[45%] bg-OUT-BlueBlack text-white rounded-3xl xl:w-[40%] h-[40vh] lg:h-[45vh]"
    >
      <p class="font-medium text-2xl lg:text-3xl">
        <span class="text-OUT-Light-Blue">OUT (Only Used Tesla)</span> listings
        are vetted by us before they are published. Each write up comes with
        verified information and essential details about your Tesla.
      </p>
      <button
        *ngIf="(auth.isAuthenticated$ | async) === false"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 transition-colors duration-400 rounded-full px-4 py-2 text-white font-semibold cursor-pointer w-"
        (click)="login()"
      >
        Create Account
      </button>
      <button
        *ngIf="(auth.isAuthenticated$ | async) === true"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 transition-colors duration-400 rounded-full px-4 py-2 text-white font-semibold cursor-pointer"
        routerLink="/used-tesla-for-sale"
      >
        Explore Listings
      </button>
    </div>
    <div class="w-full xl:w-[45%] h-[40vh] lg:h-[45vh]">
      <img
        src="/assets/images/ModelS_66.webp"
        class="rounded-3xl object-cover w-full h-full"
        alt=""
      />
    </div>
  </section>
</section>
